import React, { FC, PropsWithChildren } from 'react'
import classNames from 'classnames'
import { FiltersParentContainer } from 'components/SA/Filters'
import PolaroidSideFilters from './PolaroidSideFilters'
import styles from './FiltersAndArtworksGrid.module.scss'
import { FilterCollapsableComponent } from '../../types'

type FiltersAndArtworksGridProps = {
  filterModalName: string
  isFiltersVisible: boolean
  filters: FilterCollapsableComponent
  isFiltersLoading: boolean
  baseUrl: string
  nextAppRoute: string
  setIsFiltersVisible: React.Dispatch<React.SetStateAction<boolean>>
  closeModal: () => void
  customClearFilterCallback?: () => void
  customShowResultsCallback?: () => void
  filteredResultsCount: number
}

const FiltersAndArtworksGrid: FC<PropsWithChildren<FiltersAndArtworksGridProps>> = ({
  filterModalName,
  isFiltersVisible,
  filters,
  isFiltersLoading,
  baseUrl,
  nextAppRoute,
  setIsFiltersVisible,
  closeModal,
  customClearFilterCallback,
  customShowResultsCallback,
  filteredResultsCount,
  children,
}) => {
  return (
    <div className={styles.mainContentGrid}>
      <div
        className={classNames(styles.left, {
          [styles.hiddenGrid]: !isFiltersVisible,
        })}
      >
        <FiltersParentContainer name={filterModalName}>
          <PolaroidSideFilters
            filters={filters}
            isFiltersLoading={isFiltersLoading}
            baseUrl={baseUrl}
            nextAppRoute={nextAppRoute}
            setIsFiltersVisible={setIsFiltersVisible}
            closeModal={closeModal}
            customClearFilterCallback={customClearFilterCallback}
            customShowResultsCallback={customShowResultsCallback}
            filteredResultsCount={filteredResultsCount}
          />
        </FiltersParentContainer>
      </div>
      <div
        className={classNames(styles.right, {
          [styles.fullGrid]: !isFiltersVisible,
        })}
      >
        {children}
      </div>
    </div>
  )
}

export default FiltersAndArtworksGrid
